import { createContext, ReactNode, RefObject, useCallback, useRef, useState } from 'react'
import { useNodeRef } from '../../../../hooks/use-node-ref'
import { TooltipData } from '../types'

type ContextProps = {
    activeId?: string
    activeTriggerRef: RefObject<HTMLElement | null>
    tooltips: Map<string, TooltipData>
    closeTooltip: () => void
    openTooltip: (triggerNode: HTMLElement | null, id: string) => void
}

type Props = {
    children?: ReactNode
}

export const PortalTooltipContext = createContext({} as ContextProps)

const PortalTooltipContextManager = ({ children }: Props) => {
    const tooltipsRef = useRef<Map<string, TooltipData>>(new Map())
    const [activeId, setActiveId] = useState<string | undefined>()
    const [activeTriggerRef, setActiveTriggerRef] = useNodeRef()

    const closeTooltip = useCallback(() => {
        setActiveTriggerRef(null)
        setActiveId(undefined)
    }, [])

    const openTooltip = useCallback((triggerNode: HTMLElement | null, id: string) => {
        setActiveTriggerRef(triggerNode)
        setActiveId(id)
    }, [])

    return (
        <PortalTooltipContext.Provider
            value={{ activeId, activeTriggerRef, tooltips: tooltipsRef.current, closeTooltip, openTooltip }}
        >
            {children}
        </PortalTooltipContext.Provider>
    )
}

export default PortalTooltipContextManager
